import { render, staticRenderFns } from "./previewPopup.vue?vue&type=template&id=18e735b0&scoped=true"
import script from "./previewPopup.vue?vue&type=script&lang=js"
export * from "./previewPopup.vue?vue&type=script&lang=js"
import style0 from "./previewPopup.vue?vue&type=style&index=0&id=18e735b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e735b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e735b0')) {
      api.createRecord('18e735b0', component.options)
    } else {
      api.reload('18e735b0', component.options)
    }
    module.hot.accept("./previewPopup.vue?vue&type=template&id=18e735b0&scoped=true", function () {
      api.rerender('18e735b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/aggregatePageManagement/components/previewPopup.vue"
export default component.exports